// extracted by mini-css-extract-plugin
export var alert = "index-module--alert--tt-E4";
export var text = "index-module--text--CJVlO";
export var icon = "index-module--icon--ejJLn";
export var textSvg = "index-module--textSvg--cYCe8";